


interface OrderConfirmedIconProps {
	className?: string,
}


const OrderConfirmedIcon = (props: OrderConfirmedIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-order-confirmed-icon"
			className={`svg-inline--fa fa-custom-order-confirmed-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 333 512">
			<path fill="currentColor" d="m97.7,80.08c4,-23.22 21.62,-40.04 41.84,-40.04l48.05,0c20.22,0 38.04,17.02 41.84,40.24l3.6,21.22l40.64,0l-4.81,-28.03c-7.21,-42.65 -41.44,-73.48 -81.49,-73.48l-48.05,0c-39.84,0 -74.08,30.83 -81.29,73.48l-4.81,28.03l40.64,0l3.6,-21.22l0.2,-0.2z"/>
			<path fill="currentColor" d="m296.51,111.52l-260.28,0c-20.02,0 -36.24,16.22 -36.24,36.24l0,327.75c0,20.02 16.22,36.24 36.24,36.24l260.28,0c20.02,0 36.24,-16.22 36.24,-36.24l0,-327.75c0,-20.02 -16.22,-36.24 -36.24,-36.24zm-44.65,137.55c-4,5.61 -7.81,11.41 -11.81,17.02c-27.43,39.24 -54.66,78.48 -82.09,117.72c-3.6,5.21 -10.81,6.81 -15.82,2c-22.62,-22.02 -45.25,-43.85 -67.67,-65.87c-9.21,-9.01 5.01,-23.22 14.22,-14.22c19.82,19.22 39.44,38.44 59.26,57.66c1.6,-2.2 3,-4.4 4.6,-6.61c27.43,-39.24 54.66,-78.48 82.09,-117.72c7.41,-10.41 24.63,-0.4 17.22,10.01z"/>
		</svg>
	);
};

export default OrderConfirmedIcon;